export default __webpack_public_path__ + "static/placeholder-ea2fece2f73e83dd6a8de160593e1ebf.png";